/**
 * Full-page navigation to the server's login routes. `browser.assign` is an
 * object property so tests can replace it (jsdom cannot navigate).
 */

export const browser = {
  assign(url: string): void {
    window.location.assign(url);
  },
};

/** Microsoft login that brings the user back to `returnTo` (a same-origin path). */
export function loginUrl(returnTo: string, opts: { selectAccount?: boolean } = {}): string {
  return `/auth/login?${opts.selectAccount ? 'prompt=select_account&' : ''}returnTo=${encodeURIComponent(returnTo)}`;
}

const AUTO_LOGIN_KEY = 'tl.autoLoginAt';
/** A second automatic login within this time means something is wrong: let the user click instead (no redirect loop). */
const AUTO_LOGIN_GUARD_MS = 2 * 60_000;

/**
 * Whether an ended session may send the user to the login automatically: not
 * when that already happened in this tab shortly before.
 */
export function claimAutoLogin(now = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(AUTO_LOGIN_KEY));
    if (Number.isFinite(last) && last > 0 && now - last < AUTO_LOGIN_GUARD_MS) return false;
    sessionStorage.setItem(AUTO_LOGIN_KEY, String(now));
  } catch {
    // Storage blocked: redirect anyway (the server-side session lifetime is hours, not seconds).
  }
  return true;
}
